import { jsx } from 'react/jsx-runtime';
import * as React from 'react';
import { forwardRef } from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgDanger(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.07 4.525c.397-.7 1.463-.7 1.86 0l7.945 14.017c.374.66-.135 1.458-.93 1.458H4.055c-.795 0-1.304-.798-.93-1.458L11.07 4.525ZM12 8c.554 0 1.004.45 1.004 1.003v3.01a1.004 1.004 0 0 1-2.008 0v-3.01C10.996 8.45 11.446 8 12 8Zm0 9.027a1.004 1.004 0 1 0 0-2.007 1.004 1.004 0 0 0 0 2.007Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);

var DangerSolid = forwardRef((props, ref) => jsx(ForwardRef, Object.assign({
  ref: ref
}, props)));

export { DangerSolid as default };
